module.exports = __webpack_public_path__ + "media/audio15.6a8385d6.mp3";